import { StreamConcurrencyConfiguration } from './StreamConcurrencyConfiguration';
import { createStreamConcurrencyManager } from './internal/StreamConcurrencyManagerImpl';
import { createStreamConcurrencyServiceImpl } from './service/StreamConcurrencyServiceImpl';
import { StreamConcurrencyService } from './StreamConcurrencyService';
import { StreamConcurrencyManager } from './StreamConcurrencyManager';
const version = '__buildVersion__';

export {
  StreamConcurrencyConfiguration,
  createStreamConcurrencyManager as createStreamConcurrencyResolver,
  createStreamConcurrencyServiceImpl as createStreamConcurrencyService,
  StreamConcurrencyService,
  StreamConcurrencyManager,
  version,
};
